import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { LoginRequestModel } from 'src/app/shared/models/request/login-request.model';
import { ResponseModel } from 'src/app/shared/models/response.model';
import { AuthoriazationModel } from 'src/app/shared/models/response/authorization.model';
import { environment } from 'src/environments/environment';
import { erroHandler } from '../erro-handler';
import { JwtTokenService } from './jwtToken.service';
import { EncryptService } from './encrypt.service';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  baseUrl = environment.api.Backend + '/auth';
  origin = '?orig=site';

  constructor(
    private jwtTokenService: JwtTokenService,
    private http: HttpClient,
    private encryptService: EncryptService
  ) {}

  login(request: LoginRequestModel) {
    request.senha = this.encryptService.encrypt(request.senha);
    return this.http
      .post<ResponseModel<AuthoriazationModel>>(`${this.baseUrl}${this.origin}`, request)
      .pipe(
        map((resp) => {
          if (resp?.data) {
            this.jwtTokenService.setToken(resp.data.token);
            this.jwtTokenService.setCurrentUserDefaultt();
          }
          return resp;
        })
      )
      .pipe(catchError(erroHandler));
  }

  loginAd(email: string, token: string) {
    return this.http
      .post<ResponseModel<AuthoriazationModel>>(`${this.baseUrl}/ad${this.origin}`, {
        email,
        token
      })
      .pipe(
        map((resp) => {
          if (resp?.data) {
            this.jwtTokenService.setToken(resp.data.token);
            this.jwtTokenService.setCurrentUserDefaultt();
            this.jwtTokenService.jwtModel.isAD = true;
          }
          return resp;
        })
      )
      .pipe(catchError(erroHandler));
  }

  refreshToken(refreshAnyway: boolean = false) {
    if (refreshAnyway || this.jwtTokenService.isTokenExpired()) {
      return this.http
        .get<ResponseModel<AuthoriazationModel>>(`${this.baseUrl}/refresh${this.origin}`)
        .pipe(
          map((response) => {
            if (response?.data) {
              this.jwtTokenService.setToken(response.data.token);
            }
            return response;
          })
        );
    }
    const resp: ResponseModel<AuthoriazationModel> = {
      success: true,
      data: {
        token: this.jwtTokenService.jwtToken
      }
    };
    return of(resp);
  }
}
